import { ArrowBack, ArrowForward } from '@mui/icons-material'
import { Box, IconButton, Skeleton, Typography } from '@mui/material'
import axios from 'api/axios'
import { useEffect, useRef, useState } from 'react'
// import useFetchAvisos from '../hooks/useFetchAvisos'
import { useContext } from 'react'
import { AvisosContext } from '../providers/AvisosProvider'
import AvisoAlert from './AvisoAlert'

const Avisos = ({ closable = true, sx = {}, mode = 'box' }) => {
  const containerRef = useRef()
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  const [avisos, setAvisos] = useState([])

  const { forceRefresh, count, avisos: response, loading, error } = useContext(AvisosContext)

  const updateScrollButtons = () => {
    const el = containerRef.current
    if (!el) return
    setCanScrollLeft(el.scrollLeft > 0)
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth)
  }

  useEffect(() => {
    forceRefresh()
  }, [])

  useEffect(() => {
    if (response) {
      setAvisos(response || [])

      updateScrollButtons()
      const el = containerRef.current
      if (!el) return

      const handleScroll = () => updateScrollButtons()
      el.addEventListener('scroll', handleScroll)
      window.addEventListener('resize', updateScrollButtons)

      return () => {
        el.removeEventListener('scroll', handleScroll)
        window.removeEventListener('resize', updateScrollButtons)
      }
    }
  }, [response])

  const handleClose = (id) => {
    setAvisos(avisos.filter((aviso) => aviso.id !== id))
    axios
      .post(`/avisos/${id}/`)
      .catch((error) => {})
      .finally(() => {
        forceRefresh()
      })
  }

  const scrollBy = (direction) => {
    containerRef.current?.scrollBy({
      left: direction * 300,
      behavior: 'smooth',
    })
  }

  return error ? (
    <Typography variant="h6" color="error">
      Error al cargar los avisos
    </Typography>
  ) : avisos.length == 0 ? (
    <></>
  ) : mode === 'box' ? (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, ...sx }}>
      {avisos.map((aviso) => (
        <AvisoAlert
          closable={closable}
          aviso={aviso}
          key={aviso.id}
          minWidth="70%"
          handleClose={handleClose}
        />
      ))}
    </Box>
  ) : mode === 'slider' ? (
    <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', ...sx }}>
      <IconButton
        onClick={() => scrollBy(-1)}
        sx={{
          flexGrow: 0,
          zIndex: 1,
          backgroundColor: 'white',
          height: '40px',
          display: { xs: 'none', sm: 'flex' },
        }}
        disabled={!canScrollLeft}
      >
        <ArrowBack />
      </IconButton>
      <Box
        ref={containerRef}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
          flexGrow: 1,
          gap: 2,
          overflowX: 'auto',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {loading ? (
          <Skeleton
            sx={{ width: '100%', height: '48px', borderRadius: '1000px' }}
            variant="rounded"
          />
        ) : (
          avisos.map((aviso) => (
            <AvisoAlert
              closable={closable}
              aviso={aviso}
              key={aviso.id}
              minWidth={{ xs: '90%', sm: '70%' }}
              handleClose={handleClose}
            />
          ))
        )}
      </Box>

      <IconButton
        onClick={() => scrollBy(1)}
        sx={{
          flexGrow: 0,
          zIndex: 1,
          backgroundColor: 'white',
          height: '40px',
          display: { xs: 'none', sm: 'flex' },
        }}
        disabled={!canScrollRight}
      >
        <ArrowForward />
      </IconButton>
    </Box>
  ) : (
    <></>
  )
}

export default Avisos
